import api from './api'
import type { ApiResponse } from './config.service'

export interface LoginRequest {
  username: string
  password: string
}

export interface UserInfo {
  displayName: string
  username: string
}

const authService = {
  async login(request: LoginRequest): Promise<UserInfo> {
    const res = await api.post<ApiResponse<UserInfo>>('/api/auth/login', request)
    return res.data
  },

  async logout(): Promise<void> {
    await api.post('/api/auth/logout')
  },

  async me(): Promise<UserInfo> {
    const res = await api.get<ApiResponse<UserInfo>>('/api/auth/me')
    return res.data
  },
}

export default authService
